var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#fff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M940 3892 c-101 -50 -105 -183 -8 -242 33 -20 54 -20 1629 -20 l1596 0 34 23 c93 62 87 189 -12 239 -32 17 -130 18 -1619 18 -1489 0 -1587 -1 -1620 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M932 2680 c-97 -59 -93 -192 8 -242 33 -17 131 -18 1620 -18 1489 0 1587 1 1619 18 101 51 106 183 9 242 -33 20 -54 20 -1628 20 -1574 0 -1595 0 -1628 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M932 1470 c-97 -59 -93 -192 8 -242 33 -17 131 -18 1620 -18 1489 0 1587 1 1619 18 101 51 106 183 9 242 -33 20 -54 20 -1628 20 -1574 0 -1595 0 -1628 -20z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.5e968535072b1f7f30fe0259e6fe7941.svg";
export { ForwardRef as ReactComponent };